// const useLocalAPI = true;
const useLocalAPI = false;

const prefix = useLocalAPI ? "http://localhost:20190" : "https://dev.livediagrams.net";

const cdAppSettings = {
  baseUrl: prefix,
  apiUrl: `${prefix}/api`,
  wsUrl: prefix,
  avaCoreServiceUrl: useLocalAPI
    ? "http://localhost:8085"
    : "https://ava-core-service-135469130251.us-central1.run.app",
};

export default cdAppSettings;
